import getUserInfo from "@api/auth/getUserInfo";
import { useCallbackRef } from "@hooks/use-callback-ref";
import type { UserContextData } from "@types_def/models/user.type";
import type React from "react";
import { useEffect, useState } from "react";

import { UserContext } from "./index.context";

function UserContextProvider({ children }: { children: React.ReactNode | React.ReactElement }) {
  const [userState, setUserState] = useState<UserContextData>();
  const [keyword, setKeyword] = useState("");

  const handleSetUser = (user: UserContextData | undefined) => {
    setUserState(user);
  };

  const onInitUserFromSession = useCallbackRef(async () => {
    const { success, data } = await getUserInfo();
    if (success && data) {
      setUserState({ ...data, connected: true });
    } else {
      setUserState((previous) => ({ ...previous, connected: false }));
    }
  });

  useEffect(() => {
    void onInitUserFromSession();
  }, [onInitUserFromSession]);

  return (
    <UserContext value={{ userState, handleSetUser, keyword, setKeyword }}>{children}</UserContext>
  );
}

export default UserContextProvider;
